export default "__VITE_ASSET__BZU_w4p7__"